export const scroll_vertically_by = (x: number) => window.scrollTo({
    top: window.scrollY + x
})
